import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from '../../../environments/environment';
import { CoDefendantForAttachment, IAddCasePageLoadLog_Request, SystemValues, SystemValuesResponse } from '../models/core.model';
import { normalizeServerString } from '../utils/convertors';
import { map } from 'rxjs';
import { FillGenericModalPicklistPayLoad } from '../models/models';

@Injectable({ providedIn: 'root' })
export class CoreApiService {
    private baseUrl: string;

    constructor(private httpClient: HttpClient) {
        this.baseUrl = environment.api.url;
    }

    public addCasePageLoadLog(fileNumber: string, defedantNumber: string) {

        const requestPayload: IAddCasePageLoadLog_Request = {
            FileNumber: fileNumber,
            DefedantNumber: defedantNumber
        }

        const url = `${this.baseUrl}WebServices/PartySearchResult.asmx/AddCasePageLoadLog`;
        return this.httpClient.post(url, requestPayload);
    }

    getSystemValues() {
        const url = `${this.baseUrl}WebServices/SystemValues.asmx/GetSystemValues`;
        return this.httpClient.post<string>(url, {}).pipe(
            map(wrapper => {
                const parsed = <SystemValuesResponse>JSON.parse(wrapper);
                return <SystemValues>{
                    fingerPrintNumberLabel: normalizeServerString(parsed.FingerPrintNumberLabel),
                    showFingerprintNumber: parsed.ShowFingerprintNumber,
                    showNeighborhood: parsed.ShowNeighborhood,
                    maintainCaseCategory: parsed.MaintainCaseCategory,
                    caseCategoryLabel: normalizeServerString(parsed.CaseCategoryLabel),
                    showBookingPD: parsed.ShowBookingPD,
                    show24HourHold: parsed.Show24HourHold,
                    showReportRcvdDate: parsed.ShowReportRcvdDate,
                    showReferredDate: parsed.ShowReferredDate,
                    referralDateLabel: normalizeServerString(parsed.ReferralDateLabel),
                    showArrestNumber: parsed.ShowArrestNumber,
                    arrestNumberLabel: normalizeServerString(parsed.ArrestNumberLabel),
                    hourlyHoldAmountJuvenile: parsed.HourlyHoldAmountJuvenile,
                    hourlyHoldAmount: parsed.HourlyHoldAmount,
                    showChildIdInAdult: parsed.ShowChildIDinAdult,
                    childIdLabel: normalizeServerString(parsed.ChildIDLabel),
                    showPrimaryPhoneNumber: parsed.ShowPrimaryPhoneNumber,
                    showAgeWithDecimal: parsed.ShowAgeWithDecimal,
                    showPrefix: parsed.ShowPrefix,
                    showStateOfBirth: parsed.ShowStateOfBirth,
                    showLocalId: parsed.ShowLocalID,
                    lIdLabel: normalizeServerString(parsed.LIDLabel),
                    stateIdLabel: normalizeServerString(parsed.StateIDLabel),
                    showStateId: parsed.ShowStateID,
                    showInmateId: parsed.ShowInmateId,
                    inmateIdLabel: normalizeServerString(parsed.InmateIDLabel),
                    showFederalId: parsed.ShowFederalId,
                    federalIdLabel: normalizeServerString(parsed.FederalIDLabel),
                    showNationality: parsed.ShowNationality,
                    nationalityLabel: normalizeServerString(parsed.NationalityLabel),
                    showDefendantStatus: parsed.ShowDefendantStatus,
                    showDLClassExp: parsed.ShowDLClassExp,
                    showIntlAddress: parsed.ShowIntlAddress,
                    showNationalityOrEmail: normalizeServerString(parsed.ShowNationalityOrEmail),
                    chargeEnhancementMethod: normalizeServerString(parsed.ChargeEnhancementMethod),
                    showJuvenileCheckbox: parsed.ShowJuvenileCheckbox,
                    requireWitnessType: parsed.RequireWitnessType,
                    showChargeEnhancement: parsed.ShowChargeEnhancement,
                    exViewShowReferralButton: parsed.ExViewShowReferralButton,
                    lblCourtLabel: normalizeServerString(parsed.lblCourtLabel),
                    systemVersion: normalizeServerString(parsed.SystemVersion),
                    externalViewNoteType: normalizeServerString(parsed.ExternalViewNoteType),
                    defendantLabel: normalizeServerString(parsed.DefendantLabel),
                    validateChargeModifier: normalizeServerString(parsed.ValidateChargeModifier),
                    externalViewDocCategory: normalizeServerString(parsed.ExternalViewDocCategory),
                    exViewShowOcn: parsed.ExViewShowOcn,
                    exViewShowLID: parsed.ExViewShowLID,
                    exViewShowStateID: parsed.ExViewShowStateID,
                    showTicketNumOnChargeGrid: parsed.ShowTicketNumOnChargeGrid,
                    showPoliceBadgeNumber : parsed.ShowPoliceBadgeNumber,
                    policeBadgeNumberLabel : normalizeServerString(parsed.PoliceBadgeNumberLabel),
                    chargeDescriptionSearchField: parsed.ChargeDescriptionSearchField,
                    showSummonDateAndNo: parsed.ShowSummonDateAndNo,
                    AllowLastNameOnlyDef : normalizeServerString(parsed.AllowLastNameOnlyDef),
                    AllowExFolderCreation: parsed.AllowExFolderCreation,
                };
            })
        );
    }

    public IsExist(strTableName: string, strColumnName: string, strColumnValue: string, bUseQuote: boolean, strWhereColumnName: string = '', strWhereColumnValue: string = '', bUseQuoteForWhere: boolean = false) {

        const path = `${this.baseUrl}WebServices/Validation.asmx/IsExist`;

        return this.httpClient.post<number>(path, {
            strTableName, strColumnName, strColumnValue, bUseQuote, strWhereColumnName, strWhereColumnValue, bUseQuoteForWhere
        }, { params: { 'showLoader': true } });
    }

    public GetValue(tableName: string, columnName: string, where: string) {

        const path = `${this.baseUrl}WebServices/Validation.asmx/GetValue`;
        return this.httpClient.post<string>(path, {
            tableName, columnName, where
        }, { params: { 'showLoader': true } });
    }

    public IsTableHasRecord(strTableName: string, strWhere: string) {

        const path = `${this.baseUrl}WebServices/Validation.asmx/IsTableHasRecord`;
        return this.httpClient.post<boolean>(path, {
            strTableName, strWhere
        }, { params: { 'showLoader': true } });
    }

    public GetValueSorted(tableName: string, columnName: string, where: string, sortBy: string) {

        const path = `${this.baseUrl}WebServices/Validation.asmx/GetValueSorted`;
        return this.httpClient.post<string>(path, {
            tableName, columnName, sortBy, where
        }, { params: { 'showLoader': true } });
    }

    public IsExistWhere(tableName: string, columnName: string, columnValue: string, where: string, useQuote: boolean) {

        const path = `${this.baseUrl}WebServices/Validation.asmx/IsExistWhere`;
        return this.httpClient.post<boolean>(path, {
            tableName, columnName, columnValue, useQuote, where
        }, { params: { 'showLoader': true } });
    }

    public FillGenericModalPicklistLazyLoad(requestPayload: FillGenericModalPicklistPayLoad) {

        const path = `${this.baseUrl}WebServices/GenericModelPickList.asmx/FillGenericModalPicklistLazyLoad`;
        return this.httpClient.post<string>(path, requestPayload, { params: { 'showLoader': true } });
    }

    public FillGenericModalPicklist(setgenericmodalpicklistperamater: number, whereCondition: string) {

        const path = `${this.baseUrl}WebServices/GenericModelPickList.asmx/FillGenericModalPicklist`;
        return this.httpClient.post<string>(path, {
            setgenericmodalpicklistperamater, whereCondition
        }, { params: { 'showLoader': true } });
    }

    public getPdName(pdName: string) {
        const url = `${this.baseUrl}WebServices/CaseInfoReferral.asmx/GetPdName`
        return this.httpClient.post<string>(url, { pdName: pdName });
    }

    public getCoDefendantsForAttachment(params: {
        caseId: string;
        parentPage: string;
    }) {
        const path = 'WebServices/CaseInfo.asmx/BindCodefendantsGrid';

        return this.httpClient
            .post<string>(environment.api.url + path, {
                currentCaseId: params.caseId,
                parentPage: params.parentPage,
            }, { params: { 'showLoader': true } })
            .pipe(
                map(wrapper =>
                    (<unknown[][]>JSON.parse(wrapper)).map(
                        parsed =>
                            <CoDefendantForAttachment>{
                                isCurrent: (parsed[0] as string).includes('Y'),
                                name: normalizeServerString(parsed[1] as string),
                                fileNumber: normalizeServerString(parsed[2] as string),
                                courtNumber: normalizeServerString(parsed[3] as string),
                                stage: normalizeServerString(parsed[4] as string),
                                status: normalizeServerString(parsed[5] as string),
                                defendantNumber: normalizeServerString(parsed[6] as string),
                            }
                    )
                )
            );
    }

    public loadBuildVersion() {
        const url = `${this.baseUrl}app/environments/buildVersion.json`;
        return this.httpClient.get<{ commitNumber: string, version: string }>(url, { withCredentials: true, headers: new HttpHeaders({ 'Content-Type': 'application/json' }) });

    }

    public isCivilCase(fileNumber: string) {
        const path = `${this.baseUrl}WebServices/CaseInfo.asmx/IsCivilCase`;
        return this.httpClient.post<boolean>(path, { fileNumber });
    }
}